import { render, staticRenderFns } from "./VisualTestExample.vue?vue&type=template&id=42981169&scoped=true"
import script from "./VisualTestExample.vue?vue&type=script&lang=js"
export * from "./VisualTestExample.vue?vue&type=script&lang=js"
import style0 from "./VisualTestExample.vue?vue&type=style&index=0&id=42981169&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42981169",
  null
  
)

export default component.exports